<template>
  <div class="invoice_container" :style="`min-height:${mh}px`">
    <div class="query_box boxshadow1">
      <div class="query_conf">
        <div class="slogo-title">历史报关单查询</div>
        <div class="query_conf_items">
          <div class="query_conf_wrap">
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">进出口标志</div>
                <div class="value">
                  <Select v-model="conf.type" placeholder="不限" clearable>
                    <Option value="">不限</Option>
                    <Option v-for="(val, key) in $options.filters.ieFlagDict()" :key="key" :value="key">{{val}}</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">商品编码</div>
                <div class="value"><Input v-model.trim="conf.code" placeholder="输入商品编码" clearable></Input></div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">目的地</div>
                <div class="value">
                  <!-- <Input v-model.trim="conf.importer" placeholder="输入目的地" clearable></Input> -->
                  <Select v-model="conf.importList" clearable multiple filterable>
                    <Option v-for="(item, idx) in areaData" :key="idx" :value="item.name">{{item.name}}</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">贸易国</div>
                <div class="value">
                  <!-- <Input v-model.trim="conf.exporter" placeholder="输入贸易国" clearable></Input> -->
                  <Select v-model="conf.exportList" clearable multiple filterable>
                    <Option v-for="(item, idx) in areaData" :key="idx" :value="item.name">{{item.name}}</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">原产国</div>
                <div class="value">
                  <!-- <Input v-model.trim="conf.origin" placeholder="输入原产国" clearable></Input> -->
                  <Select v-model="conf.originList" clearable multiple filterable>
                    <Option v-for="(item, idx) in areaData" :key="idx" :value="item.name">{{item.name}}</Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="query_conf_items">
          <div class="query_conf_wrap">
            <div class="query_conf_item" style="width: 40%">
              <div class="query_conf_item_wrap">
                <div class="title">FTA</div>
                <div class="value">
                  <Select v-model="conf.ftaList" clearable multiple>
                    <Option v-for="(item, idx) in ftaData" :key="idx" :value="item.id">{{item.name}}</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">企业名称</div>
                <div class="value"><Input v-model.trim="conf.enterprise" placeholder="输入企业名称" clearable></Input></div>
              </div>
            </div>
            <div class="query_conf_item" style="width: 40%">
              <div class="query_conf_item_wrap">
                <div class="title">申报日期</div>
                <div class="value">
                  <DatePicker class="dateselect" v-model.trim="dateRange" type="daterange" placement="bottom-start" split-panels clearable :editable="false" placeholder="请选择日期" @on-change="dateSearch" style="width:100%;"></DatePicker>
                </div>
              </div>
            </div>
            <!-- <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">城市地区</div>
                <div class="value"><Input v-model.trim="conf.city" placeholder="输入城市地区"></Input></div>
              </div>
            </div> -->
          </div>
        </div>

        <div class="query_conf_items">
          <div class="query_conf_wrap">
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">批次号</div>
                <div class="value">
                  <Select filterable v-model="conf.batch" clearable>
                    <Option v-for="(item, idx) in batchData" :key="idx" :value="item">{{item}}</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">报关单号</div>
                <div class="value">
                  <Input v-model.trim="conf.customsCode" placeholder="输入报关单号" clearable></Input>
                </div>
              </div>
            </div>



          
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">货物总价</div>
                <div class="value" style="display: flex; align-items: center;height: 32px">
                  <InputNumber v-model.trim="conf.amountMin" :min="0.01" placeholder="最小值"></InputNumber>
                  <span style="padding:0 8px">到</span>
                  <InputNumber v-model.trim="conf.amountMax" :min="0.01" placeholder="最大值"></InputNumber>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btns_wrap">
          <Button type="primary" class="btn search" @click.prevent="searchHandle"><span>搜索</span></Button>
          <Button type="primary" class="btn reset" @click.prevent="resetHandle" :disabled="searching"><span>{{$t('btn.reset')}}</span></Button>
          <Button type="ghost" class="export_btn" :loading="exporting" icon="ios-search" @click.prevent="exportFile">
            <span v-if="!exporting">导出</span>
            <span v-else>导出中</span>
          </Button>
          <Tooltip content="根据查询条件导出全部数据"><svg-icon icon-class="help"></svg-icon></Tooltip>
        </div>
      </div>
    </div>

    <div class="query_result boxshadow1" style="position:relative;">
      <div class="running" v-if="isRun" style="position: absolute; right: 3px; top: 3px; background-color: #1d8a02; padding: 0 5px; color: #fff; font-size: 12px; border-radius: 3px;">报关单分析中: {{runNum}}</div>
      <div class="content">
        <Row :gutter="5">
          <Col span="4" class="ac_cc ac_c1"><div class="title">总票数</div><div class="value">{{statData.count || 0}}</div></Col>
          <Col span="7" class="ac_cc ac_c2"><div class="title">理论节税总额<span v-if="statData.currencySystem">({{statData.currencySystem}})</span></div><div class="value">{{(statData.benefitAmount || 0) | amountThousands}}</div></Col>
          <Col span="7" class="ac_cc ac_c3"><div class="title">实际节税总额<span v-if="statData.currencySystem">({{statData.currencySystem}})</span></div><div class="value">{{(statData.benefitAmountActual || 0) | amountThousands}}</div></Col>
          <Col span="3" class="ac_cc ac_c4 actions">
            <Button type="ghost" class="upload" :loading="uploading" icon="ios-search" @click.prevent="importFile">
              <span v-if="!uploading">导入</span>
              <span v-else style="font-size:12px">导入中<span style="display: none"> 100%</span></span>
            </Button>
            <input type="file" ref="fileInput" @change="fileChange($event)" class="upload-input">
            <a href="https://otech-rcep.oss-cn-hangzhou.aliyuncs.com/%E4%BA%AB%E6%83%A0%E5%88%86%E6%9E%90/%E4%BA%AB%E6%83%A0%E5%88%86%E6%9E%90%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx" target="_blank" class="dw_tpl">模板下载</a>
          </Col>
          <Col span="3" class="ac_cc ac_pager">
            <Page :total="query.total" :current="currentPageNumber" :page-size="pageSize" size="small" @on-change="getQueryList"></Page>
          </Col>
        </Row>
        <div class="table-containter">
          <div class="table-wrap">
            <Table :columns="query.columns" :data="query.list" no-data-text="暂无记录"></Table>
          </div>
        </div>
        <div class="pager-wrap">
          <Page :total="query.total" :current="currentPageNumber" :page-size="pageSize" size="small" @on-change="getQueryList"></Page>
          <div class="pager-elevator">
            <span>前往</span><InputNumber :max="totalPage || 1" :min="1" :step="1" size="small" v-model="currentPage" @on-blur	="onElevatorBlur"></InputNumber><span>页</span><Button @click="onElevator">确定</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
import { saveAs } from 'file-saver'

export default {
  name: 'EnjoyDiscountList',
  components: { Loader },
  props: ['mh'],
  data () {
    return {
      conf: {
        type: '',
        code: '',
        importer: '',
        importList: [],
        exporter: '',
        exportList: [],
        origin: '',
        originList: [],
        ftaId: '',
        ftaList: [],
        enterprise: '',
        startTime: null,
        endTime: null,
        city: '',
        batch: '',
        amountMin: null,
        amountMax: null
      },
      isRun: false,
      runNum: 0,
      ftaData: [],
      batchData: [],
      areaData: [],
      statData: {},
      uploading: false,
      exporting: false,
      dateRange: '',
      isShowModalLoader: false,
      searching: false,
      pageSize: 10,
      currentPage: 1,
      currentPageNumber: 1,
      totalPage: 1,
      query: {
        total: 0,
        columns: [
          {title: '批次号', key: 'batch', align: 'center', minWidth: 150, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.batch} }, params.row.batch || '-')
          }},
          {title: '报关单号', key: 'customsCode', align: 'center', minWidth: 200, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.customsCode} }, params.row.customsCode || '-')
          }},
          {title: '进出口类型', key: 'type', align: 'center', minWidth: 200, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.type} }, params.row.type || '-')
          }},
          {title: '起运地', key: 'importer', align: 'center', minWidth: 200, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.exporter} }, params.row.exporter || '-')
          }},
          {title: '目的地', key: 'exporter', align: 'center', minWidth: 200, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.importer} }, params.row.importer || '-')
          }},
          {title: '境内收货人', key: 'consigneeDomestic', align: 'center', minWidth: 180, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.consigneeDomestic} }, params.row.consigneeDomestic || '-')
          }},
          {title: '境外发货人', key: 'consigneeOverseas', align: 'center', minWidth: 180, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.consigneeOverseas} }, params.row.consigneeOverseas || '-')
          }},
          {title: '监管方式', key: 'regulatedMode', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.regulatedMode} }, params.row.regulatedMode || '-')
          }},
          {title: '成交方式', key: 'transactionMode', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.transactionMode} }, params.row.transactionMode || '-')
          }},
          {title: '数量', key: 'count', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.count} }, params.row.count)
          }},
          {title: '运费', key: 'freightFee', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            if (params.row.freightFee || params.row.freightFee === 0) {
              return h('span', { attrs: {title: this.$options.filters.amountThousands(params.row.freightFee)} }, this.$options.filters.amountThousands(params.row.freightFee))
            } else {
              return h('span', '-')
            }
          }},
        
          {title: '保费', key: 'insuranceFee', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            if (params.row.insuranceFee || params.row.insuranceFee === 0) {
              return h('span', { attrs: {title: this.$options.filters.amountThousands(params.row.insuranceFee)} }, this.$options.filters.amountThousands(params.row.insuranceFee))
            } else {
              return h('span', '-')
            }
          }},
          {title: '保费模式', key: 'insuranceMode', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: this.$options.filters.feeModeDict(params.row.insuranceMode || '-')} }, this.$options.filters.feeModeDict(params.row.insuranceMode || '-'))
          }},
          {title: '保费币制', key: 'insuranceCs', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.insuranceCs} }, params.row.insuranceCs || '-')
          }},
          {title: '杂费', key: 'otherFee', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            if (params.row.otherFee || params.row.otherFee === 0) {
              return h('span', { attrs: {title: this.$options.filters.amountThousands(params.row.otherFee)} }, this.$options.filters.amountThousands(params.row.otherFee))
            } else {
              return h('span', '-')
            }
          }},
          {title: '杂费模式', key: 'otherMode', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: this.$options.filters.feeModeDict(params.row.otherMode || '-')} }, this.$options.filters.feeModeDict(params.row.otherMode || '-'))
          }},
          {title: '杂费币制', key: 'otherCs', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.otherCs} }, params.row.otherCs || '-')
          }},
          {title: '毛重(KG)', key: 'weightTotal', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.weightTotal} }, params.row.weightTotal || '-')
          }},
          {title: '净重(KG)', key: 'weightNet', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.weightNet} }, params.row.weightNet || '-')
          }},
          {title: '可享惠金额', key: 'customsBenefit', align: 'center', minWidth: 180, ellipsis: true, render: (h, params) => {
            if (params.row.customsBenefit || params.row.customsBenefit === 0) {
              return h('span', { attrs: {title: '¥' + this.$options.filters.amountThousands(params.row.customsBenefit)} }, '¥' + this.$options.filters.amountThousands(params.row.customsBenefit))
            } else {
              return h('span', '-')
            }
          }},


      
          {title: '状态', key: 'freightCs', align: 'center', minWidth: 120, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.status} }, params.row.status || '-')
          }},
        
       
         
         
         
        
          { title: '操作', key: 'action', align: 'center', fixed: 'right', width: 90, render: (h, params) => {
            return h('div', { class: 'opr' }, [
              h('a', {class: 'row-detail', on: {
                click: event => {
                  event.stopPropagation()
                  event.preventDefault()
                  let routeUrl =  this.$router.resolve({name: 'EnjoyResult', params: { id: params.row.id }})
     window.open(routeUrl .href, '_blank');

                 
                }
              }}, '查看详情')
            ])
          }}
        ],
        list: []
      },
    }
  },
  created () {
    this.$nextTick(() => {
      // this.getQueryList()
      // this.getStatData()
      this.getFtaData()
      this.getBatchData()
      this.getAreaData()
      this.getAnalysis()
     
    })
  },
  methods: {
    getAnalysis () {
      this.$api.benefit.getAnalysis({
        success: response => {
          if (response.data.code === 200) {
            this.isRun = response.data.data.run != 0
            if (this.isRun) {
              this.runNum = response.data.data.run
              setTimeout(() => {
                this.getAnalysis()
              }, 2000)
            }
          }
        },
        error: errorMsg => {}
      })
    },
    getAreaData () {
      this.$api.getAreaData({
        success: response => {
          if (response.data.code === 200) {
            this.areaData = response.data.data
          }
        },
        error: errorMsg => {}
      })
    },
    getBatchData () {
      this.$api.getBatchData({
        success: response => {
          if (response.data.code === 200) {
            this.conf.batch = ''            
            this.batchData = response.data.data
          }
        },
        error: errorMsg => {}
      })
    },
    getFtaData () {
      this.$api.getFtaData({
        success: response => {
          if (response.data.code === 200) {
            this.ftaData = response.data.data
          }
        },
        error: errorMsg => {}
      })
    },
    getStatData () {
      this.$api.benefit.stat2(_.assign(
        _.pickBy(this.conf, (v, k) => !!v), _.pickBy({
        ftaList: this.conf.ftaList.join(','), importList: this.conf.importList.join(','),
        exportList: this.conf.exportList.join(','), originList: this.conf.originList.join(',')
      }, (v, k) => !!v)), {
        success: response => {
          if (response.data.code === 200) {
            this.statData = response.data.data || {}
          }
        },
        error: errorMsg => {}
      })
    },
    getQueryList(page = 1) {
      if (this.isShowModalLoader) return
      this.isShowModalLoader = true
      this.searching = true
      this.$Loading.start()
      this.currentPageNumber = page
      this.currentPage = page
      this.$api.benefit.getList(this._.assign({page: page || 1, size: this.pageSize}, _.pickBy(this.conf, (v, k) => !!v), _.pickBy({
        ftaList: this.conf.ftaList.join(','), importList: this.conf.importList.join(','),
        exportList: this.conf.exportList.join(','), originList: this.conf.originList.join(',')
      }, (v, k) => !!v)), {
        success: response => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.query.list = response.data.data.result || []
            this.query.total = response.data.data.count || 0
            this.totalPage = response.data.data.pageCount || 0
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), duration: 1.5, closable: true})
          }
          this.isShowModalLoader = false
          this.searching = false
        },
        error: errorMsg => {
          this.isShowModalLoader = false
          this.searching = false
          this.$Message.error({content: this.$t('common.tryAgain'), duration: 1.5, closable: true})
          this.$Loading.error()
        }
      })
    },
    dateSearch (dateArr, dateType) {
      if (!this._.isEmpty(dateArr) && dateType === 'date') {
        this.conf.startTime = dateArr[0]
        this.conf.endTime = dateArr[1]
      } else {
        this.conf.startTime = null
        this.conf.endTime = null
        this.dateRange = ''
      }
    },
    searchHandle () {
      if (this.conf.amountMin && this.conf.amountMax && this.conf.amountMin > this.conf.amountMax) {
        this.$Message.info({content: '货币总价区间最小值>最大值', duration: 1.5, closable: true})
      } else {
        this.getQueryList(1)
        this.getStatData()
      }
    },
    onElevator () {
      this.getQueryList(this.currentPage || 1)
    },
    resetHandle () {
      this.conf = {type: '', code: '', importer: '', importList: [], exporter: '', exportList: [], origin: '', originList: [], ftaId: '', ftaList: [], enterprise: '', startTime: null, endTime: null, city: '', batch: '', amountMin: null, amountMax: null}
      this.dateRange = ''
    },
    onElevatorBlur () {
      if (!this.currentPage) {
        this.currentPage = 1
      } else if (this.currentPage > this.totalPage) {
        this.currentPage = this.totalPage
      }
    },
    importFile () {
      if (!this.uploading) {
        this.$refs.fileInput.click()
      }
    },
    fileChange (event) {
      const files = event.target.files
      if (!files || files.length === 0) return
      this.uploadFiles(files)
    },
    uploadFiles (files) {
      if (!files || files.length === 0) return
      let isRefused = false
      this._.each(files, (file) => {
        if (file.size > 100 * 1024 * 1024) {
          this.$Message.error({content: '上传文件过大，请上传不超过100M的文件', duration: 1.5, closable: true})
          isRefused = true
          return false
        }
        let suffix = this._h.getSuffix(file.name)
        if (this._.indexOf(['.xls', '.xlsx'], suffix) === -1) {
          this.$Message.error({content: '上传文件类型错误，请上传Excel文件', duration: 1.5, closable: true})
          isRefused = true
          return false
        }
      })
      if (isRefused) {
        this.$refs.fileInput.value = null
        return
      }
      if (!this.uploading) {
        this.$Loading.start()
        this.uploading = true
        let formData = new FormData()
        formData.append('file', files[0])
        this.$api.upload('benefit/import', formData, {
          success: response => {
            if (response.data.code === 200) {
              this.$Message.success({content: '上传成功', duration: 1.5})
              if (!this.isRun) {
                this.getAnalysis()
              }
              this.getQueryList(1)
              this.getBatchData()
              this.$Loading.finish()
              this.uploading = false
              this.$refs.fileInput.value = null
            } else {
              this.$Loading.error()
              if (this._.indexOf([203001, 203002, 203003], response.data.code) !== -1) {
                this.$Message.error({content: response.data.message, duration: 2, closable: true})
              } else {
                this.$Message.error({content: response.data.message || '文件解析失败，请重试', duration: 2, closable: true})
              }
              this.uploading = false
              this.$refs.fileInput.value = null
            }
          },
          error: errorMsg => {
            this.$Loading.error()
            this.$Message.error({content: errorMsg || '文件上传失败，请重试', duration: 2, closable: true})
            this.uploading = false
            this.$refs.fileInput.value = null
          }
        })
      }
    },
    exportFile () {
      if (this.exporting) return
      this.exporting = true
      this.$api.benefit.export(this._.assign( _.pickBy(this.conf, (v, k) => !!v), _.pickBy({ ftaList: this.conf.ftaList.join(','),
       importList: this.conf.importList.join(','),
        exportList: this.conf.exportList.join(','), originList: this.conf.originList.join(',')
      }, (v, k) => !!v)), {
        success: response => {
          const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
          let filename = decodeURIComponent(response.headers['content-disposition'].split("filename=")[1])
          if (filename) {
            saveAs(blob, filename)
          } else {
            saveAs(blob, `享惠分析-${this.$options.filters.dataFormat(Date.now(), 'dateTime.f3')}.xlsx`)
          }
          this.exporting = false
        },
        error: errorMsg => {
          this.$Message.error({content: errorMsg || '导出失败，请重试', duration: 1.5, closable: true})
          this.exporting = false
        }
      })
    },
  }
}
</script>

<style scoped>
.invoice_container{
  background-color: #fff;
  padding: 5px 0 0;
}
.query_box{
  margin-bottom: 30px;
}
.query_result{
  padding: 6px 18px 24px;
}
.query_conf{
  font-size: 14px;
  padding: 18px 18px 22px;
}
.slogo-title{
  color: #323232;
  font-weight: bold;
  font-size: 15px;
  padding: 0 18px 10px 0;
}
.query_conf_title{
  color: #999;
  font-size: 14px;
  margin-bottom: 6px;
  padding-left: 16px;
  background: url("~@/assets/images/home/rate2.png") no-repeat 0 center transparent;
  background-size: 11px;
}
.query_conf_title.keys{
  background: url("~@/assets/images/home/pro2.png") no-repeat 0 5px transparent;
  background-size: 11px;
}
.query_conf_wrap{
  margin-left: -10px;
  margin-right: -10px;
  display: flex;
  flex-wrap: wrap;
}
.query_conf_item{
  width: 20%;
}
.query_conf_item_wrap{
  margin: 0 10px 14px;
}
.query_conf_item_wrap .title{
  font-size: 15px;
  margin-bottom: 4px;
}
.query_conf_item_wrap >>> .ivu-input,
.query_conf_item_wrap >>> .ivu-select-selection,
.query_conf_item_wrap >>> .ivu-input-number,
.query_conf_item_wrap >>> .ivu-select-input{
  border-color: #b1b1b1;
  border-radius: 2px;
  font-size: 15px;
}
.query_conf_item_wrap >>> .ivu-tag-text{
  font-size: 15px;
}
.query_conf_item_wrap >>> .ivu-input-number{
  height: 30px;
  box-sizing: content-box;
  line-height: 30px;
}
.query_conf_item_wrap >>> .ivu-input-number-input{
  height: 30px;
  line-height: 30px;
}
.query_conf_item_wrap >>> .ivu-input-number-input::placeholder{
  font-size: 15px;
}
.query_conf_item_wrap >>> .ivu-select-selected-value{
  font-size: 15px !important;
}
.query_conf_item_wrap >>> .ivu-select-placeholder{
  font-size: 15px !important;
}
.query_conf_item_wrap >>> .ivu-select-item{
  font-size: 15px !important;
}
.btns_wrap{
  height: 32px;
  margin-top: 10px;
}
.btn{
  max-width: 180px;
  width: 18.4%;
  border: 1px solid #8892f3;
  border-radius: 3px;
  height: 32px;
  float: left;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  letter-spacing: 2px;
}
.btn span{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.btn.search{
  background-color: #8892f3;
  color: #fff;
}
.btn.ivu-btn-loading{
  cursor: default;
}
.btn.ivu-btn-loading span{
  position: static;
  transform: none;
}
.btn.reset{
  background-color: #fff;
  color: #8892f3;
  margin-left: 20px;
}
.btn.reset[disabled]{
  color: #bbbec4;
  border-color: #dddee1;
  cursor: default;
}
.opr_acitons{
  padding: 16px 18px;
  margin-bottom: 30px;
}
.actions{
  position: relative;
}
.actions .add{
  border: 1px solid #bc8cf0;
  background-color: #bc8cf0;
  color: #fff;
}
.upload-input{
  display: none;
}
.actions >>> .ivu-btn{
  border-radius: 2px;
  width: 65px;
  font-size: 15px;
}
.actions >>> .ivu-btn .ivu-icon-ios-search{
  background: url("~@/assets/images/home/add.png") 0 center no-repeat transparent;
  background-size: 14px;
  width: 14px;
  height: 14px;
  position: relative;
  top: 2px;
}
.actions >>> .upload.ivu-btn .ivu-icon-ios-search{
  background-image: url("~@/assets/images/home/export.png");
}
.actions >>> .del.ivu-btn .ivu-icon-ios-search{
  background-image: url("~@/assets/images/home/del.png");
}
.actions >>> .ivu-btn>.ivu-icon+span, .ivu-btn>span+.ivu-icon{
  margin-left: 2px;
}
.actions >>> .ivu-btn .ivu-icon-ios-search:before{
  content: "";
}
.actions .upload{
  border: 1px solid #8892f3;
  background-color: #8892f3;
  color: #fff;
  padding: 2px 0;
  font-size: 14px;
}
.actions .del{
  border: 1px solid #8ac3fa;
  background-color: #8ac3fa;
  color: #fff;
  margin-right:20px;
}
.actions .copy{
  border-color: #0774b5;
  color: #0774b5;
}
.actions .copy[disabled]{
  color: #ccc;
  border-color: #ccc;
}
.actions .copy >>> .ivu-icon{
  font-size: 20px;
  position: relative;
  top: 2px;
}
.actions .right_action{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
}
.actions .right_action .cert_btn{
  color: #1F8AFD;
  background: url("~@/assets/images/coo/icon_zhengshuguanli.png") 0 center no-repeat transparent;
  background-size: 13px auto;
  padding-left: 16px;
}
.actions .right_action .dw_tpl{
  display: inline-block;
  margin-left: 10px;
  font-size: 15px;
}
.actions .right_action .dw_tpl:hover{
  text-decoration: underline;
}
.content{
  margin-top: 20px;
  position: relative;
}
.table-containter{
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 3px;
  margin-top: 10px;
}
.table-wrap{
  width: 100%;
  border: 1px solid #ccc;
}
.table-wrap >>> .ivu-table-wrapper{
  /* width: 2300px; */
}
.table-wrap >>> .opr{
  white-space: nowrap;
}
.table-wrap >>> .ivu-table-body tr:nth-child(even) td{
  /* background-color: #eaf7ff; */
}
.table-wrap >>> .ivu-table:before, .table-wrap >>> .ivu-table:after{
  background-color: #eaf7ff;
}
.table-wrap >>> .ivu-table-overflowX{
  /* max-height: calc(100vh - 30vh); */
}
.content >>> .ivu-table-wrapper{
  border: 0 none;
}
.content >>> .ivu-table{
  color: #686765;
}
.content >>> .ivu-table th{
  background-color: #fff;
  font-size: 14px;
  font-weight: bold;
  border-color: #ccc;
  white-space: nowrap;
  border-bottom-width: 0.5px;
  border-right: 0.5px solid #ccc;
  color: #333;
}
.content >>> .ivu-table th span{
  white-space: nowrap;
}
.content >>> .ivu-table td{
  font-size: 15px;
  border-width: 0;
  border-right: 0.5px solid #ccc;
  border-bottom: 0.5px solid #ccc;
}
.content >>> .ivu-table .ivu-checkbox-wrapper{
  margin-right: 0;
}
.content >>> .ivu-table .tb_select .ivu-table-cell{
  padding-right: 0;
}
.content >>> .ivu-table .tb_company .ivu-table-cell{
  padding-left: 0;
}
.content >>> .ivu-table .opr a.line2:after{
  bottom: 0;
}
.ivu-page{
  margin-top: 20px;
  margin-bottom: 16px;
  text-align: right;
}
.ivu-page >>> a{
  font-size: 15px;
}
.ivu-page >>> a:hover{
  color: #0774b5;
}
.ivu-page >>> .ivu-page-prev a, .ivu-page >>> .ivu-page-next a{
  font-size: 22px;
}
.ivu-page >>> .ivu-page-item{
  margin: 0 5px;
}
.ivu-page >>> .ivu-page-item-active{
  background-color: #0774b5;
  border-color: #0774b5;
}
.ivu-page >>> .ivu-page-total{
  font-size: 15px;
}
.ivu-page >>> .ivu-page-options-elevator{
  font-size: 15px;
}
.ivu-page >>> .ivu-page-options-elevator input{
  font-size: 15px;
}
.ivu-page >>> .ivu-page-item a, .ivu-page >>> .ivu-page-next a, .ivu-page >>> .ivu-page-prev a{
  color: #8892f3;
}
.ivu-page >>> .ivu-page-disabled a{
  color: #999;
}
.ivu-page >>> .ivu-page-item-active{
  background-color: transparent;
  border: 0 none;
}
.ivu-page >>> .ivu-page-item-active a{
  color: #333;
}
.pager-wrap .ivu-page >>> .ivu-page-prev .ivu-icon-ios-arrow-left,
.pager-wrap .ivu-page >>> .ivu-page-next .ivu-icon-ios-arrow-right{
  position: relative;
  top: -3px;
}
.ivu-page >>> .ivu-page-prev .ivu-icon-ios-arrow-left::before{
  content: "上一页";
  font-size: 15px;
}
.ivu-page >>> .ivu-page-next .ivu-icon-ios-arrow-right::before{
  content: "下一页";
  font-size: 15px;
}
.ivu-page >>> .ivu-page-item-jump-next a, .ivu-page >>> .ivu-page-item-jump-prev a,
.ivu-page >>> .ivu-page-item-jump-next:after, .ivu-page >>> .ivu-page-item-jump-prev:after{
  color: #8892f3;
}
.pager-wrap{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.pager-elevator{
  margin-left: 20px;
  font-size: 15px;
  display: flex;
  align-items: center;
}
.pager-elevator >>> .ivu-input-number{
  margin: 0 10px;
  width: 48px;
  font-size: 15px;
}
.pager-elevator >>> .ivu-input-number-handler-wrap{
  display: none;
}
.pager-elevator >>> .ivu-btn{
  background-color: #8892f3;
  border-color: #8892f3;
  color: #fff;
  margin-left: 10px;
  padding: 3px 8px;
  border-radius: 2px;
  font-size: 13px;
}
.ac_pager >>> .ivu-page{
  margin: 0;
}
.ac_pager >>> .ivu-page-item,
.ac_pager >>> .ivu-page-item-jump-prev,
.ac_pager >>> .ivu-page-item-jump-next{
  display: none;
}
.ac_pager >>> .ivu-page-prev .ivu-icon-ios-arrow-left::before,
.ac_pager >>> .ivu-page-next .ivu-icon-ios-arrow-right::before{
  font-size: 14px;
}
.ac_c1,.ac_c2,.ac_c3,.ac_c4{
  display: flex;
  align-items: center;
}
.ac_c1{
  justify-content: flex-end;
}
.ac_cc .title{
  color: #555;
  font-size: 15px;
  padding-right: 10px;
}
.ac_cc .value{
  background-color: #bc8cf0;
  color: #fff;
  padding: 2px 8px;
  font-size: 15px;
  min-width: 50px;
  text-align: center;
}
.ac_c2, .ac_c3, .ac_c4{
  justify-content: center;
}
.ac_c2 .value{
  background-color: #ffa799;
}
.ac_c3 .value{
  background-color: #8ac3fa;
}
.dw_tpl{
  font-size: 14px;
  white-space: nowrap;
  position: relative;
  left: 15px;
  color: #8892f3;
}
.dw_tpl:hover{
  color: #333;
}
.export_btn{
  margin-left: 20px;
  border: 1px solid #ffa799;
  background-color: #ffa799;
  color: #fff;
  font-size: 15px;
  border-radius: 3px;
  height: 32px;
  width: 100px;
}
.export_btn >>> .ivu-icon-ios-search{
  background-image: url("~@/assets/images/home/import.png");
  background-size: 14px;
  position: relative;
  top: 0 !important;
  width: 14px;
  height: 14px;
}
.export_btn >>> .ivu-icon-ios-search::before{
  content: "";
}
.export_btn span,
.export_btn >>> .ivu-icon{
  position: relative;
  top: -2px
}
.btns_wrap >>> .ivu-tooltip{
  position: relative;
  top: 3px;
  margin-left: 10px;
}
.btns_wrap >>> .svg-icon{
  font-size: 20px;
}
.table-wrap >>> .row-detail{
  font-size: 14px;
  color: #0774b5;
}
.table-wrap >>> .row-detail:hover{
  color: #055f94;
}
</style>


// WEBPACK FOOTER //
// src/components/Enjoy/DiscountList.vue